var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('el-input',{attrs:{"placeholder":_vm.default_placeholder,"clearable":"","size":"mini","suffix-icon":"el-icon-search"},on:{"change":_vm.goSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }